import { CloseSiderButton } from "shared-components/ViewFragments/SearchResults/Sider/CloseSiderButton/web";
import { Button } from "antd";
import dynamic from "next/dynamic"
import { useEffect } from "react";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";
const Filters = dynamic(() => import("shared-components/ViewFragments/SearchResults/Sider/Filters/web"), { ssr: false })

const SiderBar = ({ sider, setSider, map, useModal = false, cleanFilters = ()=>{}, updateUrlOnRealTime= true }) => {
	const {updateURL} =useSearchResultsFilters();

	const modalStyle = {
        width: 'auto',
        height: 'auto',
    };

	/**
	 * Si la url  no se actualiza al aplicar filtros (`updateUrlOnRealTime`=false)
	 * con este código se actualiza al cerrar el modal
	 * Es un fix para iOS que da problemas al actualizar la url cuando hay algo con poistion = fixed en la pantalla
	 */
	useEffect(() => {
		if(!updateUrlOnRealTime && !sider) {
			updateURL();
		}
	}, [sider]);


    useEffect(() => {
        const handlePopState = () => {
            if (sider) {
                setSider(false);
                window.history.pushState(null, null, window.location.href);
            }
        };

        if (sider) {
            window.history.pushState(null, null, window.location.href);
            window.addEventListener("popstate", handlePopState);
        }

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [sider]);

	if (useModal) {
		return (
			<div
				className={`modal-backdrop ${sider ? "modal-open" : "modal-close"}`}
				onClick={()=> setSider(false)}
			>
				<div onClick={(event)=>{event.stopPropagation()}} className="modal" style={modalStyle}>
					<div className="modal-body" style={{padding: 0}}>
						<div className='sider-desktop'>
							<div className={`search-filters open`}>
								<div className='filter-header more-filter-title'>
									<span>Más Filtros</span>

									<svg onClick={() => { setSider(false) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" aria-hidden="true" role="presentation" focusable="false" style={{ display: "block", fill: "none", height: "16px", width: "16px", stroke: 'currentcolor', strokeWidth: 3, overflow: "visible", position: "absolute", right: 20 }}><path d="m6 6 20 20M26 6 6 26"></path></svg>
								</div>

								<div style={{ padding: 20, paddingBottom: 70, overflow: 'scroll', maxHeight: 'calc(90vh - 80px)' }}>
									{/* <ActiveFiltersTags /> */}
									<Filters map={map} updateUrlOnRealTime={updateUrlOnRealTime}/>
								</div>

								<div
									className="filter-footer"
								>
									<button
										className="button button-secondary"
										onClick={() => {cleanFilters()}}
									>
										{/*icono de papelera*/}
										Limpiar Filtros
									</button>
									<button
										className="button button-primary"
										onClick={() => setSider(false)}
									>
										Ver propiedades
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	} else {
		return <div className={`search-filters ${sider ? "open" : ""}`}>
				<CloseSiderButton sider={sider} setSider={setSider} />
				{/* <ActiveFiltersTags /> */}
				{/* <CreateSearchAlert /> */}
				<Filters map={map} updateUrlOnRealTime={updateUrlOnRealTime} />
				<CloseSiderButton sider={sider} setSider={setSider} showSearchResults />
		</div>
	}

}

export default SiderBar